<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div class="card shadow-sm border-0">
    <div class="card-body">

        <!-- ═══════════════════════════════════════════════════════════════
                Filter Bar: inline ≥1024px | 2-row stacked on tablet
           ════════════════════════════════════════════════════════════════════ -->
        <div class="filter-bar d-flex flex-wrap align-items-end gap-2 mb-3">
        
            <!-- Search -->
            <div class="filter-bar__search">
                <div class="position-relative">
                    <input type="text" class="form-control emp-search-input shadow-none" placeholder="Type here…"
                        [(ngModel)]="searchText" (input)="performSearch()" />
                    <span class="search-icon"><i class="bi bi-search"></i></span>
                </div>
            </div>
        
            <!-- Employer dropdown -->
            <div class="filter-bar__employer">
                <label class="filter-label">Employer</label>
                <div class="searchable-dropdown">
                    <div class="dropdown-input-wrapper">
                        <input type="text" class="form-control shadow-none input-text" [value]="getSelectedCompanyName()"
                            (input)="onFilterCompanySearchChange($event)" (focus)="openCompanyDropdown()"
                            (blur)="onCompanyBlur()" placeholder="All Employers" autocomplete="off" />
                        <span class="input-group-text"><i class="bi bi-chevron-down"></i></span>
                    </div>
                    <div class="dropdown-list" *ngIf="companyDropdownOpen && filteredCompanies().length > 0">
                        <div class="dropdown-item" [class.selected]="!filterCompanyId" (mousedown)="selectCompany(null)">
                            <span class="bank-name">All Employers</span>
                        </div>
                        <div class="dropdown-item" *ngFor="let c of filteredCompanies()" (mousedown)="selectCompany(c)"
                            [class.selected]="filterCompanyId === c.companyId">
                            <span class="bank-name">{{ c.companyName }} ({{ c.companyId }})</span>
                        </div>
                    </div>
                    <div class="dropdown-list no-results" *ngIf="companyDropdownOpen && filteredCompanies().length === 0">
                        <div class="dropdown-item">No employers found</div>
                    </div>
                </div>
            </div>
        
            <!-- Advanced Filter -->
            <div class="filter-bar__actions">
                <app-filter-panel #filterPanel title="Advanced Filter" [fields]="filterFields"
                    (filterApplied)="onFilter($event)" (filterCleared)="onClear()">
                </app-filter-panel>
            </div>
        
            <!-- Reset -->
            <div class="filter-bar__actions">
                <button type="button" class="btn btn-secondary" [disabled]="!isServerFilterApplied" (click)="onClear()">
                    <i class="bi bi-arrow-counterclockwise me-1"></i>Reset
                </button>
            </div>
        
        </div>

      <!-- Loading -->
      <div *ngIf="isLoading" class="text-muted py-3">Loading employees…</div>

      <!-- Error state -->
      <div *ngIf="!isLoading && error" class="alert alert-danger py-3">
        <i class="bi bi-exclamation-triangle me-2"></i>{{ error }}
      </div>

      <!-- Empty state -->
      <div *ngIf="!isLoading && !error && filteredEmployees.length === 0" class="text-center py-5">
        <i class="bi bi-inbox fs-1 text-muted mb-3 d-block"></i>
        <p class="text-muted">No employees found.</p>
      </div>

      <!-- Table -->
      <div *ngIf="!isLoading && !error && filteredEmployees.length > 0" class="table-responsive-wrapper">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="table-title text-start">Employee ID</th>
              <th class="table-title text-start">First Name</th>
              <th class="table-title text-start">Last Name</th>
              <th class="table-title text-start">NIC / Passport</th>
              <th class="table-title text-start">Email</th>
              <th class="table-title text-start">Mobile</th>
              <th class="table-title text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let emp of filteredEmployees">
              <td class="table-data-text text-start">{{ emp.employeeId }}</td>
              <td class="table-data-text text-start">{{ emp.firstName | titlecase }}</td>
              <td class="table-data-text text-start">{{ emp.lastName  | titlecase }}</td>
              <td class="table-data-text text-start">{{ emp.nic   || '—' }}</td>
              <td class="table-data-text text-start">{{ emp.email || '—' }}</td>
              <td class="table-data-text text-start">{{ emp.mobile || '—' }}</td>
              <td class="table-data-text text-center">
                <span
                  class="badge rounded-pill text-nowrap"
                  [ngClass]="getStatusBadgeClass(emp.status)">
                  {{ emp.status }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <app-paginator
          [serverSide]="true"
          [totalItems]="totalEmployees"
          [pageSize]="pageSize"
          [activePage]="currentPage"
          [pageSizeOptions]="[10, 20, 50]"
          (pageChangeServer)="onPageChange($event)">
        </app-paginator>
      </div>

    </div>
  </div>

</div>
